import bgCoaching from './assets/images/imgteam.jpg'

const sales =
  {
    coachings: [
      {
        name: '1-1 Coaching',
        slug: '1-1-coaching',
        duration: '1 month',
        homeCoachingBulletPoints: [
          'Individual training sessions',
          'Physical presence of a Personal Trainer',
          'Train from the comfort of your home',
          'Nutrition guidance',
          'Contact me anytime'
        ],
        onlineCoachingBulletPoints: [
          'Personalized fitness program',
          'Weekly follow up with a Personal Trainer',
          'Flexible training schedule',
          'Nutrition guidance',
          'Contact me anytime'
        ],
        price: '120',
        img_url: bgCoaching
      }
    ]
  }


export default sales
